export function init_datepicker() {

    $.fn.datepicker.dates['fi']['format'] = "dd.mm.yyyy";

    $('input.datepicker').data({behaviour: "datepicker"}).datepicker({
        language: CURRENT_LOCALE,
        autoclose           : true,
        calendarWeeks       : true,
        todayHighlight      : true,
        todayBtn            : 'linked',
    });

    $('input.multidatepicker').data({behaviour: "datepicker"}).datepicker({
        language: CURRENT_LOCALE,
        autoclose           : true,
        calendarWeeks       : true,
        todayHighlight      : true,
        todayBtn            : 'linked',
        multidate           : true,
    });

    $('.date_time').datepicker({
        language: CURRENT_LOCALE,
        autoclose           : true,
        calendarWeeks       : true,
        todayBtn            : 'linked',
    });

    $('.time_picker').timepicker({
        // Setting template as dropdown will show a redundant element, which is just confusing for the user
        // Setting template as modal will make the window vertical scrollbar disappear...
        // So using the false value, which will prevent the tab key, but this problem can be circumvented with the time_picker_fix CSS class and keydown handler
        template            : false, // dropdown (default), modal, false
        minuteStep          : 5,
        disableFocus        : true,
        showMeridian        : false,
        defaultTime         : false,
    });

}

global.initDatePickerElements = function() {
    init_datepicker();
}

$(document).on('click', '.datepicker_now_button', function(event) {
    var _this  = $(this);
    var set_values = true;
    var target_date = _this.attr('data-target-date');

    if($(target_date).length == 0) {
        target_date = _this.parent().prev().next('input.date_time_picker');
    }
    if($(target_date).length != 0) {
        set_values = ($(target_date).val().length < 10);
        if (set_values) {
            var date = _this.attr('data-date');
        } else {
            var date = '';
        }
        $(target_date).val(date);
    }
    var target_time = _this.attr('data-target-time');
    if($(target_time).length != 0) {
        set_values = ($(target_time).val().length < 5);
        if (set_values) {
            var time = getCurrentTime();
        } else {
            var time = '';
        }
        $(target_time).val(time);
    }
});

$(document).on('keydown', '.time_picker_fix', function(event) {
    var index = $(this).index("input");
    if (event.keyCode == 9) {
        if (event.shiftKey) {
            $("input").eq(index - 1).focus();
        } else {
            $("input").eq(index + 1).focus();
        }
    }
});

$(document).on('turbolinks:load', init_datepicker);
